import { IconPropSize } from '@consta/icons/Icon';

import { Space } from '##/mixs/MixSpace';

import { FieldPropSize } from '../types';

export const iconSizeMap: Record<FieldPropSize, IconPropSize> = {
  xs: 'xs',
  s: 's',
  m: 's',
  l: 's',
};

export const iconSpaceMap: Record<FieldPropSize, Space> = {
  xs: '2xs',
  s: '2xs',
  m: '2xs',
  l: 'xs',
};
